import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../../../../providers/root-store-provider';
import { DropdownMenu } from '../../../dropdown/menu/dropdown-menu';
import { DropdownMenuItem } from '../../../dropdown/menu/item/dropdown-menu-item';
import { routes } from '../../../../../config/routes';
import { IconSettings } from '../../../icons/settings';
import { getPortfolios } from '../../../../../utils/get-portfolios';
import { AssetPortfolioSimpleRegular } from '../../../asset/portfolio/simple/regular/asset-portfolio-simple-regular';
import { AssetPortfolioSimpleSummary } from '../../../asset/portfolio/simple/summary/asset-portfolio-simple-summary';
import { PortfolioExpandExcluded } from '../../expand-excluded/portfolio-expand-excluded';

export const PortfolioMenuMobile: React.FC = observer(() => {
    const { t } = useTranslation();
    const { portfolioStore, themeStore, statisticStore } = useRootStore();

    const router = useRouter();
    const isIndex = router.pathname === routes.app.index;

    const { summary, activePortfolios, excludedPortfolios } = getPortfolios();

    const canShowSummary = portfolioStore.portfolios.length > 2;
    const [excludedExpanded, setExcludedExpanded] = useState(false);

    return (
        <DropdownMenu>
            <div className="px-xsmall py-xsmall">
                <li className="flex flex-col gap-[0.6rem] pb-[1rem]">
                    {activePortfolios.map((row) => (
                        <AssetPortfolioSimpleRegular
                            key={row.id}
                            data={row}
                            showAllAssets={true}
                            onClick={async () => {
                                await portfolioStore.selectPortfolio(row.id);
                                if (isIndex) {
                                    await statisticStore.profitStore.fetchProfitCharts();
                                }
                            }}
                        />
                    ))}

                    {summary && canShowSummary ? (
                        <AssetPortfolioSimpleSummary
                            data={summary}
                            onClick={async () => {
                                await portfolioStore.selectPortfolio(summary.id);
                                if (isIndex) {
                                    await statisticStore.profitStore.fetchProfitCharts();
                                }
                            }}
                        />
                    ) : null}

                    {excludedPortfolios.length > 0 ? (
                        <>
                            <PortfolioExpandExcluded
                                excludedExpanded={excludedExpanded}
                                setExcludedExpanded={setExcludedExpanded}
                                excludedPortfolios={excludedPortfolios.length}
                            />
                            {excludedExpanded
                                ? excludedPortfolios.map((row) => (
                                      <AssetPortfolioSimpleRegular
                                          key={row.id}
                                          data={row}
                                          showAllAssets={true}
                                          onClick={async () => {
                                              await portfolioStore.selectPortfolio(row.id);
                                              if (isIndex) {
                                                  await statisticStore.profitStore.fetchProfitCharts();
                                              }
                                          }}
                                      />
                                  ))
                                : null}
                        </>
                    ) : null}
                </li>
                <DropdownMenuItem
                    onClick={async () => {
                        await router.push(routes.app.portfolios);
                        themeStore.hideMobilePortfolioNavigation();
                    }}
                    icon={<IconSettings />}
                    name={t('layout.portfolioMenu.portfolioManagement')}
                />
            </div>
        </DropdownMenu>
    );
});
